import { Col, Row} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { PlasticCodes } from '../../enums';
import { useCallback } from 'react';

//================================================================

export default function ItemDetails({item}){

  //----------------------------------------------------------------

  const displayPlasticCode = useCallback(() => {

    const keys = item.plastic_codes.map((plasticCode) => {
      const key = Object.keys(PlasticCodes).find(key => PlasticCodes[key]['value'] === plasticCode);
      if (key){
        return PlasticCodes[key]['name'];
      } else {
        return `BAD VALUE ${item.plastic_code}`;
      }
    });

    return keys;
  });

  //----------------------------------------------------------------

  return(
    <>
      { item ?
        <Row className="mb-4" xs={1}>
          {/*<Col className="text-truncate">
            <b>ID:</b> {item._id || ""}
          </Col>*/}

          <Col>
            <b>{"Item Description: "}</b>{item.item_description || ""}
          </Col>

          <Col>
            <b>{"Environment Description: "}</b>{item.env_description || ""}
          </Col>

          <Col>
            <b>Geocoordinates:</b>{' '}
            { item.geocoordinates &&
              <>
                <Link
                  to={`https://www.openstreetmap.org/?mlat=${item.geocoordinates.lat}&mlon=${item.geocoordinates.lon}&zoom=${process.env.REACT_APP_OSM_ZOOM}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  View on OpenStreetMap
                </Link>
                {Object.entries(item.geocoordinates).map(([key,value]) =>
                  <li key={`geocoordinates-${key}-${value}`}>
                    {key}: {value}
                  </li>
                )}
              </>
            }
          </Col>

          <Col>
            <b>Plastic Codes:</b> {displayPlasticCode().join(", ") || ""}
          </Col>

          <Col>
            <b>{"State: "}</b>{item.item_state || ""}
          </Col>

          <Col>
            <b>{"Tags: "}</b>{item.tags.join(", ")}
          </Col>

          { item.created &&
            <Col>
              <b>{"Added On: :"}</b>{new Date(item.created * 1000).toLocaleString()}
            </Col>
          }

          { item.modified &&
            <Col>
              <b>{"Last Updated: "}</b>{new Date(item.modified * 1000).toLocaleString()}
            </Col>
          }

          <Col>
            {item.is_private ? "Private" : "Public"}
          </Col>
        </Row>
        :
        <Col className="text-center">
          {"Unable to load Item"}
        </Col>
      }
    </>
  );
}
